

const hamburgerMenuButton = document.getElementById('hamburgerMenuButton');
const navigationWrapper = document.getElementById('navigationWrapper');

const headerDropdowns = document.querySelectorAll('header .menu-item-has-children');
const body = document.body
let status;

if (headerDropdowns.length > 0){
    headerDropdowns.forEach(dropdown=>{

        const subMenu = dropdown.querySelector('.sub-menu');
        const trigger = dropdown.querySelector('a');

        trigger.addEventListener('click', ()=>{
            dropdown.classList.toggle('active');
        })

    })
}

hamburgerMenuButton.addEventListener('click', ()=>{
    status = hamburgerMenuButton.dataset.status;
    if (status === 'open') {
        hamburgerMenuButton.dataset.status = 'closed';
        body.classList.remove('overflow-hidden');
        navigationWrapper.dataset.status = 'closed'
    }else{
        hamburgerMenuButton.dataset.status = 'open';
        body.classList.add('overflow-hidden');
        navigationWrapper.dataset.status = 'open'
        // testWrap.focus()
    }
})